import UpsellAddedCard from './UpsellAddedCard';

export default UpsellAddedCard;
